import React, { useState } from "react";
import PageHeader from "./PageHeader.jsx";

const TAKE_OPTIONS = [
  { value: 'Love it', emoji: '😍', color: '#48bb78' },
  { value: 'Like it', emoji: '😊', color: '#38a169' },
  { value: "It's ok", emoji: '😐', color: '#ecc94b' },
  { value: 'Meh', emoji: '😕', color: '#ed8936' },
  { value: 'WTF', emoji: '😱', color: '#f56565' }
];

export default function HotTakes({ user, go }) {
  const [target, setTarget] = useState('');
  const [code, setCode] = useState('');
  const [genderChoice, setGenderChoice] = useState('male');
  const [names, setNames] = useState([]);
  const [name, setName] = useState('');
  const [take, setTake] = useState('');
  const [note, setNote] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const loadNames = async () => {
    if (!target) return;
    setIsLoading(true);
    const url = `/api/stats/${target}?code=${encodeURIComponent(code)}&gender=${genderChoice}`;
    const res = await fetch(url);
    if (!res.ok) {
      setNames([]);
      setIsLoading(false);
      return;
    }
    const data = await res.json();
    const getRating = n => {
      const r = data.ranking[n];
      return typeof r === 'number' ? r : (r ? r.rating : 0);
    };
    const sorted = data.accepted.slice().sort((a, b) => getRating(b) - getRating(a));
    setNames(sorted);
    setName('');
    setIsLoading(false);
  };

  const submit = async () => {
    if (!name || !take) return;
    setIsLoading(true);
    await fetch(`/api/user/${user.username}/takes`, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ target, name, take, note, code })
    });
    setTake('');
    setNote('');
    setIsLoading(false);
  };

  return (
    <div className="page">
      <PageHeader
        title="Hot Takes 🔥"
        description="Share your honest thoughts on someone's favorite names. Be kind, but be real!"
      />

      <div className="card">
        <h3>🎯 Find Someone's List</h3>
        <div className="lookup-row">
          <input
            className="lookup-main"
            placeholder="Enter their username..."
            value={target}
            onChange={e => setTarget(e.target.value)}
          />
          <input
            className="lookup-code"
            placeholder="Code"
            value={code}
            onChange={e => setCode(e.target.value)}
          />
          <select className="lookup-select" value={genderChoice} onChange={e => setGenderChoice(e.target.value)}>
            <option value="male">Boy</option>
            <option value="female">Girl</option>
            <option value="neutral">Neutral</option>
          </select>
          <button onClick={loadNames} disabled={!target || isLoading}>
            {isLoading ? 'Loading...' : 'Load Names'}
          </button>
        </div>
      </div>

      {names.length > 0 && (
        <div className="card">
          <h3>💝 {target}'s Favorites</h3>
          <div style={{ marginBottom: '1.5rem' }}>
            <select
              value={name}
              onChange={e => setName(e.target.value)}
              style={{ marginBottom: '1rem' }}
            >
              <option value="">Choose a name to review...</option>
              {names.slice(0, 10).map((n, i) => (
                <option key={n} value={n}>{`${i + 1}. ${n}`}</option>
              ))}
            </select>
            <textarea
              placeholder="Add a thoughtful note (optional)..."
              value={note}
              onChange={e => setNote(e.target.value)}
              style={{ marginBottom: '1rem' }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h4>Your Take:</h4>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                gap: '0.75rem'
              }}
            >
              {TAKE_OPTIONS.map(opt => (
                <button
                  key={opt.value}
                  className={take === opt.value ? 'btn-primary' : 'btn-secondary'}
                  onClick={() => setTake(opt.value)}
                  style={take === opt.value ? { backgroundColor: opt.color } : {}}
                >
                  {`${opt.emoji} ${opt.value}`}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={submit}
            disabled={!name || !take || isLoading}
            className="btn-primary"
            style={{ width: '100%', padding: '1rem' }}
          >
            {isLoading ? 'Sending...' : '💌 Send Your Take'}
          </button>
        </div>
      )}
    </div>
  );
}
